<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{this.lastReevaluatedBy}}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
        </ng-template>
    </incident-dialog-content>
    <form [formGroup]="incidentForm" autocomplete="off" *ngIf="showUserInput">
        <h2>Missing Requirement(s)</h2>
        <table class="mvd_table--primeng">
            <thead>
                <tr>
                    <th>Incident ID</th>
                    <th>Missing Incident Type</th>
                    <th>Other Requirement</th>
                    <th class="w--icon">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let doc of data.incident.missingDocuments">
                    <td>{{doc.incidentMissingRequirementTypeId}}</td>
                    <td>{{doc.incidentMissingRequirementTypeDisplayValue}}</td>
                    <td>{{doc.otherRequirement}}</td>
                    <td class="text-center"><a class="icon--delete" title="Delete" href="javascript:void(0)" (click)="deleteRequirement(doc.incidentMissingRequirementTypeId)" *ngIf="!data.isReadOnly"></a></td>
                </tr>
            </tbody>
        </table>
        <div class="row" *ngIf="!data.isReadOnly">
            <div class="col-sm-4 mvd_form-group">
                <user-input type="list" [parent]="this" label="Missing Requirement" name="requirementTypeList" id="requirementTypeList" [isRequired]="false" [showRequired]="true" [list]="incidentMissingRequirementTypes" listValueMember="value" listDisplayMember="text" catchChange="true" catchChangeIndex="0"></user-input>
            </div>
            <div class="col-sm-4 mvd_form-group" *ngIf="showOtherRequirement()">
                <user-input type="text" [parent]="this" label="Other Requirement" name="otherRequirement" id="otherRequirement" [isRequired]="false" [showRequired]="true"></user-input>
            </div>
            <div class="col-sm-4 mvd_form-group">
                <button class="icon--add btn--default" type="button" (click)="addRequirement()">Add Selected</button>
            </div>
        </div>
    </form>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>